// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9ce166b3","732":"802b460d","977":"11b5f6ae"}[chunkId] + ".chunk.js";
};